export async function loadLegacyVendors() {
    const [waypointModule, countUpModule] = await Promise.all([
        import("../Vendor/jquery.waypoints.min.js"),
        import("../Vendor/countUp.umd.js")
    ]);

    const CountUp =
        countUpModule.CountUp ||
        (countUpModule.default && countUpModule.default.CountUp) ||
        countUpModule.default ||
        window.CountUp ||
        (window.countUp && window.countUp.CountUp);

    const Waypoint =
        window.Waypoint ||
        waypointModule.Waypoint ||
        (waypointModule.default && waypointModule.default.Waypoint) ||
        waypointModule.default;

    return {
        CountUp,
        Waypoint
    };
}
